import { Component } from 'react'
import { getLanguageFromPath } from '@constants/languages'
import { ERROR_BOUNDARY_TRANSLATIONS } from '@constants/errorBoundaryTranslations'
import styles from './ErrorBoundary.module.css'

/**
 * Global Error Boundary - catches render errors and displays fallback UI.
 * Uses static translations via getLanguageFromPath (no provider dependency).
 */
class ErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    if (import.meta.env.DEV) {
      console.error('[ErrorBoundary] Render error caught:', error)
      console.error('[ErrorBoundary] Component stack:', info.componentStack)
    }
  }

  handleReload = () => {
    window.location.reload()
  }

  handleGoHome = () => {
    const lang = getLanguageFromPath()
    window.location.href = `/${lang}`
  }

  render () {
    if (this.state.hasError) {
      const lang = getLanguageFromPath()
      const t = ERROR_BOUNDARY_TRANSLATIONS[lang] || ERROR_BOUNDARY_TRANSLATIONS.es

      return (
        <main className={styles.errorPage}>
          <div className={styles.content} role='alert' aria-live='assertive'>
            <h1 className={styles.title}>{t.title}</h1>
            <p className={styles.message}>{t.message}</p>
            <div className={styles.actions}>
              <button
                type='button'
                onClick={this.handleReload}
                className={styles.button}
              >
                {t.reload}
              </button>
              <button
                type='button'
                onClick={this.handleGoHome}
                className={styles.link}
              >
                {t.home}
              </button>
            </div>
          </div>
        </main>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
